import Text from '@/components/react-native/text';
import TouchableOpacity from '@/components/react-native/touchable-opacity';
import View from '@/components/react-native/view';
import {airportNoteCatTitle} from '@/services/community';
import {getAirport} from '@/services/diversion';
import {IAirportInfo} from '@/types/airport';
import React, {useCallback, useMemo, useState} from 'react';

// Section components with memoization
export const AirportHeader = React.memo(
  ({
    airportNoteInfo,
    showButtonToViewFullAirportInfo,
    onEditInfo,
    preview
  }: {
    airportNoteInfo: IAirportInfo;
    showButtonToViewFullAirportInfo?: boolean;
    onEditInfo?: () => void;
    preview?: boolean;
  }) => {
    const airport = useMemo(() => {
      return getAirport(airportNoteInfo.icao_code);
    }, [airportNoteInfo]);
    const country = useMemo(() => {
      if (!airport) return '';
      return airportNoteInfo?.country ?? '';
    }, [airport]);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    // AIP file upload state
    const [isAipUploadModalVisible, setIsAipUploadModalVisible] =
      useState(false);

    // AIP file upload handlers
    const handleUploadAipFile = useCallback(() => {
      setIsAipUploadModalVisible(true);
    }, []);

    const handleCloseAipModal = useCallback(() => {
      setIsAipUploadModalVisible(false);
      setSelectedFile(null);
    }, []);

    const handleFileSelect = useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
          setSelectedFile(file);
        }
      },
      []
    );

    const handleFileUpload = useCallback(async () => {
      if (!selectedFile || !airportNoteInfo?.icao_code) return;

      try {
        // TODO: Implement actual file upload logic here
        console.log(
          'Uploading AIP file:',
          selectedFile.name,
          'for airport:',
          airportNoteInfo.icao_code
        );

        // Simulate upload process
        // await uploadAipFile(airportNoteInfo.icao_code, selectedFile);

        console.log('AIP file uploaded successfully');
        handleCloseAipModal();
      } catch (error) {
        console.error('Error uploading AIP file:', error);
        // TODO: Show error toast to user
      }
    }, [selectedFile, airportNoteInfo, handleCloseAipModal]);

    const handleRunChecker = useCallback(() => {
      if (!airportNoteInfo?.icao_code) return;

      try {
        // TODO: Implement actual checker logic here
        console.log('Running checker for airport:', airportNoteInfo.icao_code);

        // Simulate checker process
        // await runAirportChecker(airportNoteInfo.icao_code);

        console.log('Checker completed successfully');
      } catch (error) {
        console.error('Error running checker:', error);
        // TODO: Show error toast to user
      }
    }, [airportNoteInfo]);

    return (
      <View className="px-0 py-[24px]">
        <View className="flex-row items-center justify-between mb-[16px]">
          <View className="flex-row items-center gap-[16px] px-[16px]">
            <Text
              fontFamily="Geist"
              className="text-[#FAFAF9] text-[24px] font-[600] tracking-[-0.48px]"
            >
              {airportNoteInfo.iata_code} / {airportNoteInfo.icao_code}
            </Text>
            <Text
              fontFamily="Geist"
              className="ml-[16p] text-[#FAFAF9] text-[16px] font-[500] tracking-[-0.32px]"
            >
              {airportNoteCatTitle(airportNoteInfo?.cat ?? '')}
            </Text>

            <Text
              fontFamily="Geist"
              className="ml-[16p] text-[#FAFAF9] text-[16px] font-[500] tracking-[-0.32px]"
            >
              {country}
            </Text>
            <Text
              fontFamily="Geist"
              className="ml-[16p] text-[#FAFAF9] text-[16px] font-[500] tracking-[-0.32px]"
            >
              {airportNoteInfo.timezone}
            </Text>
          </View>
          {/* {!preview && (
            <View className="flex-row gap-[12px] px-[16px]">
              <TouchableOpacity
                className="flex-1 flex-row items-center justify-center gap-[8px] px-[8px] py-[8px] bg-[#38BDF8] rounded-[6px]"
                onClick={handleUploadAipFile}
              >
                <Text className="text-white text-[16px] font-bold">📄</Text>
                <Text
                  fontFamily="Geist"
                  className="text-white text-[14px] font-[500] tracking-[-0.28px] whitespace-nowrap"
                >
                  Upload AIP File
                </Text>
              </TouchableOpacity>

              <TouchableOpacity
                className="flex-1 flex-row items-center justify-center gap-[8px] px-[8px] py-[8px] bg-[#10B981] rounded-[6px]"
                onClick={handleRunChecker}
              >
                <Text className="text-white text-[16px] font-bold">✓</Text>
                <Text
                  fontFamily="Geist"
                  className="text-white text-[14px] font-[500] tracking-[-0.28px] whitespace-nowrap"
                >
                  Run Checker
                </Text>
              </TouchableOpacity>
            </View>
          )} */}
        </View>

        <View className="flex-row items-center justify-between px-[16px]">
          <View className="flex-row items-center gap-[16px]">
            <Text
              fontFamily="Geist"
              className="text-[#FAFAF9] text-[16px] font-[500] tracking-[-0.32px]"
            >
              Effective: {airportNoteInfo.effective}
            </Text>
            <Text
              fontFamily="Geist"
              className="text-[#FAFAF9] text-[16px] font-[500] tracking-[-0.32px]"
            >
              Version: {airportNoteInfo.version}
            </Text>
            <Text
              fontFamily="Geist"
              className="text-[#FAFAF9] text-[16px] font-[500] tracking-[-0.32px]"
            >
              Published: {airportNoteInfo.published}
            </Text>
          </View>
          {!preview && onEditInfo && (
            <TouchableOpacity
              className="flex-row items-center gap-[8px] px-[12px] py-[8px] bg-[rgba(56,189,248,0.1)] border border-[#38BDF8] rounded-[4px]"
              onClick={onEditInfo}
            >
              <Text
                fontFamily="Geist"
                className="text-[#38BDF8] text-[14px] font-[500] tracking-[-0.28px]"
              >
                Edit Info
              </Text>
            </TouchableOpacity>
          )}
        </View>
        {/* AIP Upload Modal */}
        {isAipUploadModalVisible && (
          <View className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <View className="bg-[#1a1a2e] rounded-[8px] p-[24px] w-[400px] max-w-[90vw]">
              <View className="flex-row items-center justify-between mb-[20px]">
                <Text
                  fontFamily="Geist"
                  className="text-white text-[18px] font-[600]"
                >
                  Upload AIP File
                </Text>
                <TouchableOpacity
                  className="w-[24px] h-[24px] items-center justify-center"
                  onClick={handleCloseAipModal}
                >
                  <Text className="text-white text-[16px] font-bold">×</Text>
                </TouchableOpacity>
              </View>

              <View className="mb-[20px]">
                <Text
                  fontFamily="Geist"
                  className="text-[#A1A1AA] text-[14px] font-[400] mb-[12px]"
                >
                  Select AIP file to upload for {airportNoteInfo?.icao_code}
                </Text>

                <input
                  type="file"
                  accept=".pdf,.doc,.docx,.txt"
                  onChange={handleFileSelect}
                  className="block w-full text-[14px] text-white file:mr-[16px] file:py-[8px] file:px-[16px] file:rounded-[4px] file:border-0 file:text-[14px] file:font-medium file:bg-[#38BDF8] file:text-white hover:file:bg-[#0EA5E9] file:cursor-pointer border border-[#374151] rounded-[4px] bg-[#111827] cursor-pointer"
                />

                {selectedFile && (
                  <Text
                    fontFamily="Geist"
                    className="text-[#10B981] text-[12px] font-[400] mt-[8px]"
                  >
                    Selected: {selectedFile.name}
                  </Text>
                )}
              </View>

              <View className="flex-row gap-[12px]">
                <TouchableOpacity
                  className="flex-1 px-[16px] py-[12px] bg-[#374151] rounded-[6px]"
                  onClick={handleCloseAipModal}
                >
                  <Text
                    fontFamily="Geist"
                    className="text-white text-[14px] font-[500] text-center"
                  >
                    Cancel
                  </Text>
                </TouchableOpacity>

                <TouchableOpacity
                  className={`flex-1 px-[16px] py-[12px] rounded-[6px] ${
                    selectedFile ? 'bg-[#38BDF8]' : 'bg-[#374151] opacity-50'
                  }`}
                  onClick={handleFileUpload}
                  disabled={!selectedFile}
                >
                  <Text
                    fontFamily="Geist"
                    className="text-white text-[14px] font-[500] text-center"
                  >
                    Upload
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        )}
      </View>
    );
  }
);

AirportHeader.displayName = 'AirportHeader';
